/*******************************************************************************
TRIGGER CUSTOM WINDOW RESIZED LISTENER
Triggers a custom event to let any function know when the window has been resized.
*******************************************************************************/

let resizeTimer;

export default function triggerWindowResizedListener() {
    $(window).on('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => { $(window).trigger('rw:window-resized'); }, 250);
    });
}
